import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    tracking: {
        tagmanager: {
            tagCode: 'GTM-KHG9F32',
        },
    },
    host: 'www.zalando-lounge.se',
});
